import script from "./FranchiseeManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./FranchiseeManagement.vue?vue&type=script&setup=true&lang=js"

import "./FranchiseeManagement.vue?vue&type=style&index=0&id=2578ec93&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2578ec93"]])

export default __exports__